import React, { Component } from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
} from '@js/components/Common/Modal';

export default class ApiExceptionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { isShowExceptionModal, closeExceptionModal, apiExceptionMessage } = this.props;

    return (
      <>
        <Modal id="exceptionModal" isShow={isShowExceptionModal}>
          <ModalHeader handleModalShown={closeExceptionModal} />
          <ModalBody>
            {apiExceptionMessage}
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-third btn__third"
              onClick={closeExceptionModal}
            >
              確認
            </button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
